import { render, staticRenderFns } from "./DemoShop.vue?vue&type=template&id=4af56088"
import script from "./DemoShop.vue?vue&type=script&lang=ts"
export * from "./DemoShop.vue?vue&type=script&lang=ts"
import style0 from "./DemoShop.vue?vue&type=style&index=0&id=4af56088&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports